<template>
  <div>
    <van-popup
      v-model="visible"
      class="HideScrollbar"
      :close-on-click-overlay="false"
      :style="{ width: '360px', height: 'auto' }"
    >
      <div class="main">
        <van-nav-bar :title="sTblid" />

        <van-radio-group v-model="radio" :checked-color="sGetConfig('color2')">
          <div v-if="sGetConfig('kioskMode') || sGetConfig('chkDisableEatIn')">
            <van-grid :column-num="1" clickable :border="false">
              <van-grid-item @click="radio = '外帶'" v-if="cols > 1">
                <van-radio name="外帶" />
                <div class="label">外帶</div>
                <div class="remark">Take Out</div>
              </van-grid-item>
            </van-grid>
          </div>
          <div v-else>
            <van-grid :column-num="cols" clickable :border="false">
              <van-grid-item @click="radio = '內用'">
                <van-radio name="內用" />
                <div class="label">內用</div>
                <div class="remark">Eat In</div>
              </van-grid-item>
              <van-grid-item @click="radio = '外帶'" v-if="cols > 1">
                <van-radio name="外帶" />
                <div class="label">外帶</div>
                <div class="remark">Take Out</div>
              </van-grid-item>
            </van-grid>
          </div>
        </van-radio-group>
        <Footer :b1="btnCarText()" :anime="checkInput()" @b1c="cmdStart()" />
      </div>
    </van-popup>
    <User ref="rUser" />
  </div>
</template>
<style scoped>
.label {
  margin-top: 1.8rem;
  font-size: 1.8rem;
}
.remark {
  color: grey;
  font-size: 1rem;
}
.van-grid {
  margin: 1rem;
}
.main {
  width: 360px;
  line-height: 2.6rem;
}
</style>
<script>
import User from "./FrmUser.vue";
export default {
  components: {
    User,
  },
  data() {
    return {
      visible: false,
      anime: true,
      radio: "",
      phone: "",
      cols: 2,
      tip: "",
      row: {},
    };
  },
  mounted() {},
  methods: {
    cmdStart() {
      
      this.$store.commit("setPotype", this.radio);
      this.visible = false;
      this.$refs.rUser.show();
    },
    async show() {
      this.sTblid != "" && (this.radio = "內用");
      this.visible = true;
    },
    display() {
      if (this.sTblid) {
        this.radio = "內用";
        this.cols = 1;
      } else {
        this.radio = "";
        this.cols = 2;
      }
      this.visible = true;
    },

    checkInput() {
      if (this.radio == "") {
        return false;
      }

      return true;
    },
    btnCarText() {
      if (this.sGetConfig('chkDisableEatIn')){
        return "用餐方式 Take Out";
      }
      
      if (this.radio == "") {
        return "用餐方式 Eat In or Take Out";
      }

      return "下一步 Next";
    },
  },
};
</script>
